import type { PropsWithChildren } from 'react';
import { tv } from '#pie/utils/TailwindUtils';

export interface TagProps extends PropsWithChildren {
  isActive?: boolean;
  href?: string;
}

export function Tag({ children, isActive = false, href }: TagProps) {
  const style = tag({ isActive });
  const Component = href ? 'a' : 'div';

  return (
    <Component className={style} href={href}>
      {children}
    </Component>
  );
}

const tag = tv({
  base: 'rounded-full flex bg-surface-subtle-gray px-4 h-9 text-sm text-content-body whitespace-nowrap items-center gap-1',
  variants: {
    isActive: {
      true: 'bg-action-primary-hover text-content-reversed',
    },
  },
});
